/* global customElements */

import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';

class LookupGrid extends BaseComponent {
		
	static get properties() {
		return {
			gridStyle: {type: String}
		};
	}

	constructor() {
		super();
		this.gridStyle = 'height: 89.5%; margin: 10px;';
		
		var lookupGrid = this;
		setTimeout(function(){
			lookupGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>
		`;
	}	
	
	init() {
		var lookupGrid = this;
		lookupGrid.allLookupTypes = [];
		
		lookupGrid.toolbar = ElementUtil.create({
			tag: 'vaadin-horizontal-layout',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-text-field',
					itemid: 'filterType',
					style: 'margin-left: 5px; width: 220px;',
					label: 'Filter By Type',
					clearButtonVisible: true,
					listeners: {
						change: function() {
							applyTypeFilter();
						},
						input: function() {
							applyTypeFilter();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'view',
					style: 'margin-left: 5px; margin-top: 18px;',
					children: [
						ElementUtil.makeIcon('lumo:eye', 'View')
					],
					disabled: true,
					listeners: {
						click: function(){
							lookupGrid.viewLookup();
						}
					}
				}
			]
		});
		
		lookupGrid.grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [				
				{						
					path: 'code',
					header: 'Type',						
					width: '9em',
					direction: 'asc'
				},
				{						
					path: 'description',
					header: 'Description',						
					'flex-grow': '1',
					width: '15em'
				},
				{						
					path: 'systemTable',
					header: 'System Table',					
					'text-align': 'center'						
				}
			],
			listeners: {
				'active-item-changed': function(event) {
				  const item = event.detail.value;
				  lookupGrid.grid.selectedItems = item ? [item] : [];
				  if (lookupGrid.grid.selectedItems.length > 0) {
					 ElementUtil.query(lookupGrid.toolbar, 'view').disabled = false; 					 
				  } else {
					 ElementUtil.query(lookupGrid.toolbar, 'view').disabled = true; 
				  }					
				}
			}
		});
		
		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				lookupGrid.toolbar,
				lookupGrid.grid
			]
		});
		lookupGrid.append(gridLayout);

		var applyTypeFilter = function() {
			var filterValue = ElementUtil.query(lookupGrid.toolbar, 'filterType').value || '';
			var filterText = filterValue.toLowerCase();
			lookupGrid.grid.activeItem = null;
			if (!filterText) {
				lookupGrid.grid.items = lookupGrid.allLookupTypes;
			} else {
				lookupGrid.grid.items = lookupGrid.allLookupTypes.filter(function(item) {
					return item.code && item.code.toLowerCase().indexOf(filterText) !== -1;
				});
			}
			var changeEvent = new CustomEvent('active-item-changed', { detail: '' });
			lookupGrid.grid.dispatchEvent(changeEvent);
		};
		
		Service.getLookupService().getLookupTypes()
			.then(function(data){
				
				var columns = lookupGrid.grid.querySelectorAll('vaadin-grid-sort-column');
				
				columns[0].renderer = function(root, column, rowData) {
					root.innerHTML = rowData.item.systemTable ? rowData.item.code : '<b>' + rowData.item.code + '</b>';
				};
				
				columns[1].renderer = function(root, column, rowData) {
					root.innerHTML = rowData.item.systemTable ? rowData.item.description : '<b>' + rowData.item.description + '</b>';
				};
				
				lookupGrid.allLookupTypes = data || [];
				applyTypeFilter();
		});
		
	}
	
	viewLookup() {
		var lookupGrid = this;
		
		var grid = lookupGrid.grid;
		var lookupTable = grid.selectedItems[0];
				
		//pop dialog
		var dialog = document.createElement('dl-dialog');
		dialog.title = lookupTable.code + ' - Values' + (lookupTable.systemTable ? ' (Read Only)' : '');
		dialog.width = 0.75;
		dialog.height = 0.8;
		dialog.fillContent = true;
		dialog.addEventListener('ready', function(){
			dialog.show();

			var toolBar = ElementUtil.create({
				tag: 'dl-toolbar',
				slot: 'toolbar',
				defaults: {
					tag: 'vaadin-button'
				},
				children: [
					{						
						children: [
							ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
						],
						listeners: {
							click: function() {	
								reloadValues();
							}
						}
					},
					{
						tag: 'vaadin-combo-box',
						itemid: 'filterstatus',						
						style: 'margin-left: 10px',
						'item-value-path': 'code',
						'item-label-path': 'desc',
						'keep-open': true,
						postinit: function(combo) {	
							combo.preventInvalidInput = false;
							combo.clearButtonVisible = false;
							combo.items = [
								{
									code: 'A',
									desc: 'Active'
								}, {
									code: 'I',
									desc: 'Inactive'
								}
							];
							combo.value = 'A';
						},
						listeners: {
							'selected-item-changed': function(event) {
								if (reloadValues){
									reloadValues();
								}
							}
						}
					},
					{						
						itemid: 'add',
						disabled: true,
						theme: 'primary',
						style: 'margin-left: 10px;',
						children: [
							ElementUtil.makeIcon('vaadin:plus', ' Add')
						],
						listeners: {
							click: function() {	
								actionAddEdit();
							}
						}
					},
					{											
						style: 'margin-left: 5px;',
						itemid: 'edit',
						disabled: true,						
						children: [
							ElementUtil.makeIcon('vaadin:edit', ' Edit')
						],
						listeners: {
							click: function() {	
								var record = valueGrid.selectedItems[0];
								actionAddEdit(record);
							}
						}
					},
					{											
						style: 'margin-left: 5px;',
						itemid: 'activate',
						disabled: true,						
						children: [
							ElementUtil.makeIcon('vaadin:check', ' Activate')
						],
						listeners: {
							click: function() {	
								var record = valueGrid.selectedItems[0];
								actionActivate(record);
							}
						}
					},					
					{						
						theme: 'primary error',
						style: 'float: right;',
						itemid: 'remove',
						disabled: true,							
						children: [
							ElementUtil.makeIcon('vaadin:close', ' Remove')
						],
						listeners: {
							click: function() {	
								actionRemove();
							}
						}
					}
				]
			});
			ElementUtil.query(toolBar, 'filterstatus').disabled = lookupTable.systemTable;	
			if (!lookupTable.systemTable) {
				ElementUtil.query(toolBar, 'add').disabled = false;
			}
			
			var valueGrid =	ElementUtil.create({
				tag: 'vaadin-grid',
				theme: 'row-stripes column-borders',
				'column-reordering-allowed': '',
				slot: 'primary',
				style: 'height: 100%;',
				defaults: {
					tag: 'vaadin-grid-sort-column',
					resizable: true
				},
				children: [
					{						
						path: 'code',
						header: 'Code',						
						width: '9em'						
					},
					{						
						path: 'description',
						header: 'Description',
						width: '9em',
						'flex-grow': '1'						
					},
					{						
						path: 'detailedDescription',
						header: 'Detailed Description',
						width: '9em'						
					},
					{						
						path: 'sortOrder',
						header: 'Sort Order',
						'text-align': 'center',
						width: '5em'						
					}
				],
				listeners: {
					'active-item-changed': function(event) {
						const item = event.detail.value;
						valueGrid.selectedItems = item ? [item] : [];
						if (valueGrid.selectedItems.length > 0 && !lookupTable.systemTable) {							
							ElementUtil.query(toolBar, 'edit').disabled = false;
							ElementUtil.query(toolBar, 'remove').disabled = false;	
							if (item.activeStatus === 'I') {
								ElementUtil.query(toolBar, 'activate').disabled = false;
								ElementUtil.query(toolBar, 'remove').disabled = true;
							} else {
								ElementUtil.query(toolBar, 'activate').disabled = true;
							}
						} else {										
							ElementUtil.query(toolBar, 'edit').disabled = true;
							ElementUtil.query(toolBar, 'remove').disabled = true;
							ElementUtil.query(toolBar, 'activate').disabled = true;
						}
					}
				}
			});

			var footer = ExportUtil.createExportFooter({
				grid: valueGrid,
				itemid: 'lookup-values',
				showDetail: false
			});

			var valuesLayout = ElementUtil.create({
				tag: 'dl-flex-layout',
				style: 'height: 100%;',
				properties: {
					contentOverflow: false
				},
				children: [
					toolBar,
					valueGrid,
					footer.footerContainer
				]
			});
			dialog.addToContentElement(valuesLayout);
			
			var reloadValues = function() {			
				var status = ElementUtil.query(toolBar, 'filterstatus').value;
				var loadMask = valueGrid.showLoading();
				Service.getLookupService().getLookupValues(lookupTable.code, status).then(function(data){
					valueGrid.activeItem = null;
					valueGrid.items = data;
					loadMask.remove();
					
					//reset buttons
					var changeEvent = new CustomEvent('active-item-changed', { detail: '' });
					valueGrid.dispatchEvent(changeEvent);
				});
			};
			reloadValues();
			
			var actionRemove = function() {
				var record = valueGrid.selectedItems[0];
				var loadMask = valueGrid.showLoading('Removing...');
				Service.getLookupService().removeLookupValue(lookupTable.code, record.code)
						.then(function(){
							loadMask.remove();	
							reloadValues();
							window.DL.MessageUtil.showToast('Success', 'Removed: ' + record.code, {
								theme: 'success'
							}); 
				});
				
			};
			
			var actionActivate = function(record) {
				var loadMask = valueGrid.showLoading('Activating...');
				Service.getLookupService().activateLookupValue(lookupTable.code, record.code)
						.then(function(){
							loadMask.remove();	
							reloadValues();
							window.DL.MessageUtil.showToast('Success', 'Activated: ' + record.code, {
								theme: 'success'
							}); 
				});
			};
			
			var actionAddEdit = function(record) {
				
				var addEditWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Add/Edit Code',	
					width: .50,
					height: 240,
					listeners: {
						ready: function() {							
							
							addEditWin.show();	
							
							var formPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-form-layout',										
										children: [
											{
												tag: 'vaadin-text-field',
												label: 'Code',
												name: 'code',
												required: true,
												maxlength: 255
											},
											{
												tag: 'vaadin-text-field',
												label: 'Label',
												name: 'description',
												maxlength: 255,
												required: true
											},
											{
												tag: 'vaadin-text-field',
												label: 'Detailed Description',
												name: 'detailedDescription',
												maxlength: 255												
											},
											{
												tag: 'vaadin-number-field',
												label: 'Sort Order',
												name: 'sortOrder',
												max: 999999,
												min: -999999,
												maxlength: 6,
												errorMessage: 'Exceeded value limit (min/max)'
											},
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:database', ' Save')
														],
														listeners: {
															click: function() {
																
																formPanel.submitForm({
																	preSubmit: function(data){
																		if (record) {
																			data.editMode = true;
																		}
																	},
																	actualCall: function(data) {
																		return Service.getLookupService().saveLookupValue(lookupTable.code, data);
																	},
																	success: function(data, responseData) {
																		reloadValues();
																		addEditWin.close();
																		window.DL.MessageUtil.showToast('Success', 'Saved: ' + data.description, {
																			theme: 'success'
																		});	
																	}
																});																
																
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {
																//cancel
																addEditWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
								
							});
							addEditWin.addToContentElement(formPanel);			
														
							if (record) {
								//load form
								formPanel.load(record);
							}
						}
					}
				});
					
				
			};
			
		});
					
	}
	
};

customElements.define('dl-lookup-grid', LookupGrid);